module.exports = __webpack_public_path__ + "78881f463cc15919bf871b8713125df9.MP3";